import React from "react";

import useTheme from "@styles/useTheme";
import useTranslation from "@languages/useTranslation";

import SidebarMenu from "@atoms/SidebarMenu";

import { useSidebarMenuItems } from "./useSidebarMenuItems";
import * as Styled from "./styles";

export type { MenuItem } from "./useSidebarMenuItems";

const SidebarMenus: React.FC = () => {

  const { theme } = useTheme();
  const { t } = useTranslation();

  const menuItems = useSidebarMenuItems();

  return (
    <Styled.Container>
      {menuItems.map(({ id, title, icon, link, end }) => (
        <SidebarMenu
          key={id}
          id={id}
          title={t(title)}
          icon={icon}
          link={link}
          end={end}
          identifierColor={theme.brand.gold}
        />
      ))}
    </Styled.Container>
  );
};

export default SidebarMenus;
